import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Select from 'react-select';

import { selectStyles } from '../../../constants/select';

import InputError from '../inputError';

const SearchableSelect = ({
  label,
  placeholder,
  hideLabel,
  name,
  options,
  value,
  error,
  errorMsg,
  onChange,
  ...props
}) => {
  const buildEvent = ({ value }) => {
    return {
      currentTarget: {
        name,
        value,
        type: 'select',
      },
    };
  };

  const onChangeOption = selectedOption => {
    const event = buildEvent(selectedOption);
    onChange(event);
  };

  const classes = classNames({
    field: true,
    'field--searchable-select': true,
    'field--hidden-label': hideLabel,
    'field--has-error': !!error,
  });

  return (
    <div className={classes} data-testid="searchableSelect">
      <label className="field__label" htmlFor={name}>
        {label}
      </label>
      <Select
        placeholder={placeholder}
        name={name}
        inputId={name}
        options={options}
        isClearable
        isSearchable
        maxMenuHeight={180}
        styles={selectStyles}
        classNamePrefix={name}
        defaultValue={value}
        onChange={onChangeOption}
        {...props}
      />
      {error && <InputError errorMsg={errorMsg} />}
    </div>
  );
};

SearchableSelect.propTypes = {
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  hideLabel: PropTypes.bool,
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  value: PropTypes.any,
  error: PropTypes.bool,
  errorMsg: PropTypes.string,
  onChange: PropTypes.func,
};

SearchableSelect.defaultProps = {
  placeholder: null,
  hideLabel: true,
  value: '',
  error: false,
  errorMsg: '',
  onChange: () => null,
};

export default SearchableSelect;
